export class LoteListModel {
    constructor(
        public id: string = '',
        public nomeArquivo: string = '',
        public qteBoletos: number = 0,
        public dataGeracao: string = ''
    ) { }
}